import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TablePagination,
  TextField,
  ListItemText,
  ListItemIcon,
  Typography,
} from "@mui/material";
import { ReactComponent as DownIcon } from "../components/directions/Down.svg";
import { ReactComponent as DownLeftIcon } from "../components/directions/DownLeft.svg";
import { ReactComponent as DownRightIcon } from "../components/directions/DownRight.svg";
import { ReactComponent as DownstairsIcon } from "../components/directions/DownStairs.svg";
import { ReactComponent as UpstairsIcon } from "../components/directions/Upstairs.svg";
import { ReactComponent as FrontLeftIcon } from "../components/directions/Left.svg";
import { ReactComponent as FrontRightIcon } from "../components/directions/Right.svg";
import { ReactComponent as RightIcon } from "../components/directions/Direction Right.svg";
import { ReactComponent as LeftIcon } from "../components/directions/Direction Left.svg";
import { ReactComponent as StraightIcon } from "../components/directions/UP.svg";

const MeetingRoomTable = ({
  meetingRooms,
  orientationOptions,
  shortNavigationOptions,
  handleOrientationChange,
  handleShortNavigationChange,
}) => {
  const [page, setPage] = useState(0);
  const rowsPerPage = 2;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  
 
  return (
    <div>
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Directions</TableCell>
              <TableCell>Short Navigation</TableCell> {/* Add new column */}
            </TableRow>
          </TableHead>
          <TableBody>
            {(rowsPerPage > 0
              ? meetingRooms.slice(
                  page * rowsPerPage,
                  page * rowsPerPage + rowsPerPage
                )
              : meetingRooms
            ).map((room) => (
              <TableRow key={room.id}>
                <TableCell>{room.name}</TableCell>
                <TableCell  >
                  <FormControl
                    variant="outlined"
                    size="small"
                    style={{ width: "200px", marginBottom: "10px"}}
                  >
                    <InputLabel>Directions</InputLabel>
                    <Select
                     
                      value={orientationOptions[room.id] || ""}
                      onChange={(e) =>
                        handleOrientationChange(room.id, e.target.value)
                      }
                     
                    >
                     
                      <MenuItem value="STRAIGHT"  style={{height:"50px", marginBottom: "5px" }}>
                        <ListItemIcon>
                          <StraightIcon />
                        </ListItemIcon>
                        <ListItemText primary="Straight" />
                      </MenuItem>
                      <MenuItem value="BACK"   style={{height:"50px", marginBottom: "5px" }}>
                        <ListItemIcon>
                          <DownIcon />
                        </ListItemIcon>
                        <ListItemText primary="Back" />
                      </MenuItem>
                      <MenuItem value="DOWNSTAIRS"  style={{height:"50px", marginBottom: "5px" }}>
                        <ListItemIcon>
                          <DownstairsIcon />
                        </ListItemIcon>
                        <ListItemText primary="Downstairs" />
                      </MenuItem>
                      <MenuItem value="UPSTAIRS"  style={{height:"50px", marginBottom: "5px" }}>
                        <ListItemIcon>
                          <UpstairsIcon />
                        </ListItemIcon>
                        <ListItemText primary="Upstairs" />
                      </MenuItem>
                      <MenuItem value="LEFT"  style={{height:"50px", marginBottom: "5px" }}>
                        <ListItemIcon>
                          <LeftIcon />
                        </ListItemIcon>
                        <ListItemText primary=" Left" />
                      </MenuItem>
                      <MenuItem value="RIGHT"  style={{height:"50px", marginBottom: "5px" }}>
                        <ListItemIcon>
                          <RightIcon />
                        </ListItemIcon>
                        <ListItemText primary="Right" />
                      </MenuItem>
                      <MenuItem value="FRONT_LEFT"  style={{height:"50px", marginBottom: "5px" }}>
                        <ListItemIcon>
                          <FrontLeftIcon />
                        </ListItemIcon>
                        <ListItemText primary="Front Left" />
                      </MenuItem>
                      <MenuItem value="FRONT_RIGHT"   style={{height:"50px", marginBottom: "5px" }}>
                        <ListItemIcon>
                          <FrontRightIcon/>
                        </ListItemIcon>
                        <ListItemText primary="Front Right" />
                      </MenuItem>
                      <MenuItem value="BACK_LEFT"   style={{height:"50px", marginBottom: "5px" }}>
                        <ListItemIcon>
                          <DownLeftIcon />
                        </ListItemIcon>
                        <ListItemText primary="Back Left" />
                      </MenuItem>
                      <MenuItem value="BACK_RIGHT"  style={{height:"50px", marginBottom: "5px" }}>
                        <ListItemIcon>
                          <DownRightIcon />
                        </ListItemIcon>
                        <ListItemText primary="Back Right" />
                      </MenuItem>
                    </Select>
                  </FormControl>
                </TableCell>
                <TableCell>
                  <TextField
                    size="small"
                    variant="outlined"
                    value={shortNavigationOptions[room.id]}
                    onChange={(e) =>
                      handleShortNavigationChange(room.id, e.target.value)
                    }
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        component="div"
        count={meetingRooms.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
      />
     
    </div>
  );
};

export default MeetingRoomTable;
